import React, {
  createContext,
  createRef,
  Dispatch,
  FC,
  RefObject,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import ReactPlayer from 'react-player'
import { BaseReactPlayerProps } from 'react-player/base'

export interface IPlayerContextState {
  playerRef: RefObject<ReactPlayer>
  player: BaseReactPlayerProps | null
  setPlayer: Dispatch<SetStateAction<BaseReactPlayerProps>>
  playerHeight: number
  setPlayerHeight: Dispatch<SetStateAction<number>>
}

const PlayerContext = createContext<IPlayerContextState>({
  playerRef: createRef<ReactPlayer>(),
  player: null,

  setPlayer: () => {},
  playerHeight: 0,
  setPlayerHeight: () => undefined,
})

export interface IAuthProviderProps {
  children: any
}

const PlayerProvider: FC<IAuthProviderProps> = ({ children }) => {
  const playerRef = useRef<ReactPlayer>(null)
  const [playerHeight, setPlayerHeight] = useState(0)
  const [playerVideo, setPlayerVideo] = useState<BaseReactPlayerProps>({
    playing: true,
    muted: true,
    volume: 0.5,
  })

  useEffect(() => {
    const handleKeyDown = () => {
      const player = document.getElementById('player')
      player?.focus()
    }
    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  return (
    <PlayerContext.Provider
      value={{
        playerRef: playerRef,
        player: playerVideo,
        setPlayer: setPlayerVideo,
        playerHeight: playerHeight,
        setPlayerHeight: setPlayerHeight,
      }}
    >
      {children}
    </PlayerContext.Provider>
  )
}

export default PlayerProvider
export const useKlassReactPlayerPlayer = () => useContext(PlayerContext)
